import React from 'react';
import PropTypes from 'prop-types';

import './Select.css';

var handleChange = function(onChange, data) {
    if (onChange) {
        onChange(data.target.value);
    }
};

var Select = function(props) {
    var options = props.options;
    var value = props.value;
    var onChange = props.onChange;
    var unselectedText = props.unselectedText;
    var label = props.label;
    var name = props.name;

    return (
        <div className="al-select-wrapper">
            <label className="al-select-label">{label || unselectedText}</label>
            <select
                onChange={function(e) { handleChange(onChange, e); }}
                value={value || ''}
                className="al-select"
                name={name}
            >
                {unselectedText && (
                    <option value="">{unselectedText}</option>
                )}
                {(options || []).map(function(opt) {
                    return (
                        <option key={opt.value} value={opt.value}>
                            {opt.display}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};

Select.propTypes = {
    options: PropTypes.array,
    value: PropTypes.string,
    onChange: PropTypes.func,
    unselectedText: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
};

export default Select;
